// Small, pure helpers used by useOrderForm. Keep behavior identical.

const stripDerivativeSuffixes = (value) =>
  (value || "")
    .replace(/\d{2}[A-Z]{3}\d+(CE|PE)$/i, "")
    .replace(/\d{2}[A-Z]{3}(FUT|CE|PE).*$/i, "")
    .replace(/[A-Z]{3}\d{2}\d+(CE|PE)$/i, "")
    .replace(/[A-Z]{3}\d{2}(FUT|CE|PE).*$/i, "")
    .replace(/\s+\d{2}[A-Z]{3}\s+(FUT|CE|PE).*$/i, "")
    .replace(/FUT$/i, "")
    .replace(/OPT.*$/i, "")
    .replace(/\d+(CE|PE)$/i, "")
    .trim();

export const extractSymbolForMargin = (exchange, trading_symbol, payload) => {
  let extractedSymbol = "";
  if (exchange === "MCX") {
    extractedSymbol = trading_symbol || payload?.trading_symbol || payload?.display_name || payload?.instrument_name || "";
    extractedSymbol = extractedSymbol
      .replace(/\d{2}[A-Z]{3}FUT$/i, "") // Remove 25AUGFUT pattern
      .replace(/\d{2}[A-Z]{3}OPT.*$/i, "") // Remove 25AUGOPT pattern
      .replace(/[A-Z]{3}\d{2}FUT$/i, "") // Remove AUG25FUT pattern
      .replace(/[A-Z]{3}\d{2}OPT.*$/i, "") // Remove AUG25OPT pattern
      .replace(/\s+[A-Z]{3}\s+FUT$/i, "") // Remove " AUG FUT" pattern
      .replace(/\s+[A-Z]{3}\s+OPT.*$/i, "") // Remove " AUG OPT" pattern  
      .replace(/\s+[A-Z]{3}$/i, "") // Remove " AUG", " SEP", " OCT" etc
      .replace(/FUT$/i, "") // Remove simple FUT suffix
      .replace(/OPT.*$/i, "") // Remove OPT and anything after it
      .replace(/\d+$/, "") // Remove any trailing numbers
      .trim();
  } else {
    extractedSymbol =
      trading_symbol ||
      payload?.trading_symbol ||
      payload?.display_name ||
      payload?.instrument_name ||
      "";
    extractedSymbol = stripDerivativeSuffixes(extractedSymbol);
  }
  return extractedSymbol;
};

const TOLERANCE = 1e-10;
export const isValidMultiple = (value, step) => {
  const remainder = Math.abs((value % step));
  return remainder < TOLERANCE || Math.abs(remainder - step) < TOLERANCE;
};

